import type { LooseObject } from '@common/types/util-types';

export type Request<APIType> = LooseObject<{
  data: APIType[];
  meta: {
    pagination: Pagination;
  },
}>;

export type AsyncListFetchHandler<APIType, Filter> = (
  offset: number | string | null,
  filter?: Filter,
  limit?: number | null,
  strategy?: boolean,
) => Promise<Request<APIType>>;

export type AsyncListCursorFetchHandler<APIType, Filter> = (
  nextCursor: string | null,
  filter?: Filter,
  limit?: number,
  strategy?: boolean,
) => Promise<Request<APIType>>;

export type Pagination = {
  limit?: number;
  offset?: number;
  total_count?: number;
  next_cursor?: string | null;
};

export type LocalState = {
  items: unknown[];
  cursor: string | null;
  pagination: Pagination;
  nextCursor: string | null;
};

export type DataManager = { get: () => LocalState, set: (newState: Partial<LocalState>) => void };

export type AsyncDataProps<APIType, ItemType, Filter> = {
  dispatch?: Function;
  filter?: Filter;
  onPostFetch?: (request: { data: APIType[] }, strategy?: string | null, filter?: Object | null) => void;
  new?: number;
  limit?: number;
  dataManager?: DataManager;
  filterFn?: (item: APIType | ItemType) => boolean;
} & ({
  useCursor: true;
  onFetch: AsyncListCursorFetchHandler<APIType, Filter>;
  nextCursor?: string | null;
  cache?: {
    items?: unknown[];
    pagination?: Pagination;
    nextCursor?: string | null;
  },
} | {
  useCursor: undefined;
  onFetch: AsyncListFetchHandler<APIType, Filter>;
  cache?: {
    items?: unknown[];
    pagination?: Pagination;
  },
});
